module.exports = __webpack_public_path__ + "static/media/arrow-down.bc1c678f.svg";